import facebookIcon from "../../assets/images/socials/facebook-icon.svg";
import linkedInIcon from "../../assets/images/socials/linkedin-icon.svg";
import twitterIcon from "../../assets/images/socials/twitter-icon.svg";
import instagramIcon from "../../assets/images/socials/instagram-icon.svg";

const socialMediaContacts = [
  {
    title: "facebook",
    icon: facebookIcon,
    link: "https://www.facebook.com/Ileeropay-110010274637216/",
  },
  {
    title: "twitter",
    icon: twitterIcon,
    link: "https://twitter.com/ileeropay",
  },
  {
    title: "linkedin",
    icon: linkedInIcon,
    link: "https://www.linkedin.com/company/ileeropay/",
  },
  {
    title: "instagram",
    icon: instagramIcon,
    link: "https://www.instagram.com/ileeropay/",
  },
];

export default socialMediaContacts;
